export const theme = {
  fontSizes: [12, 14, 16, 20, 24, 32],
  palette: {
    primary: {
      main: "#007CFB",
      dark: "#005EC0",
    },
    neutral: {
      dark: "#545D61",
      medium: "#BEC9D5",
      light: "#fafafa",
      veryLight: "#F1F5F9",
      white: "#fff",
    },
    accent: {
      blue: "#26B9E7",
      tiel: "#32D1CD",
      green: "#2EC17A",
      lightGreen: "#89E42D",
      yellow: "#F5D73F",
      orange: "#F5843F",
      red: "#FB5C00",
      purple: "#B657EE",
    },
    text: {
      // primary: "#545D61",
      primary: "#FFF",
      // secondary: "#545d61",
      secondary: "#FFF",
    },
    background: "#eaeff4",
  },
  textStyles: {
    dateBig: {
      fontSize: "4.69rem",
      fontFamily: "Grenze",
      fontWeight: 200,
      textAlign: "right",
      lineHeight: "8rem",
    },
    slideDescription: {
      fontSize: "1.13rem",
      textAlign: "right",
      fontFamily: "Open Sans",
    },
    slideDescription2: {
      fontSize: "1rem",
      fontFamily: "Open Sans",
    },
    slideDescriptionTop: {
      fontSize: "1.13rem",
      textAlign: "left",
      fontFamily: "Open Sans",
      maxWidth: "60%",
      padding: "0 1rem",
    },
    slideDescriptionLarge: {
      fontSize: "3rem",
      textAlign: "center",
      fontFamily: "Grenze",
      maxWidth: "80%",
      padding: "0 1rem",
      fontWeight: 200,
      lineHeight: "3rem",
      color: "#fafafa",
    },
    slideTitle: {
      color: "#fff",
      fontFamily: "Grenze",
      fontWeight: 200,
      fontSize: "3.65rem",
      backgroundColor: "#000",
      display: "inline",
      padding: "0 0.5rem",
      paddingBottom: "0.3rem",
      boxDecorationBreak: "clone",
      lineHeight: 1.27,
    },
    slideDescriptionMap: {
      color: "black",
      fontFamily: "Open Sans",
      fontWeight: 400,
      fontSize: "1rem",
      backgroundColor: "#fff",
      padding: "0.7rem",
      paddingBottom: "0.3rem",
      lineHeight: 1.27,
      width: "100%",
    },
    chapterTitle: {
      color: "#fff",
      fontFamily: "Open Sans",
      fontSize: "1rem",
    },
    modalTitle: {
      fontFamily: "Grenze",
      fontSize: "2.5rem",
      fontWeight: 800,
      textAlign: "left",
    },
    modalText: {
      color: "#1e262a",
      fontFamily: "Open Sans",
      fontSize: "0.875rem",
      marginBottom: "1.5rem",
      letterSpacing: "0.02rem",
      lineHeight: "1.5rem",
    },
    creditsCategory: {
      fontFamily: "Open Sans",
      color: "#0f0f29",
      marginBottom: "0.5rem",
      textTransform: "uppercase",
      fontSize: "0.8rem",
      fontWeight: 700,
    },
    creditsItem: {
      fontFamily: "Open Sans",
      fontSize: "0.9rem",
      marginBottom: "1.2rem",
      lineHeight: 1.6,
      color: "white",
    },

    movieTitle: {
      fontFamily: "Grenze",
      fontWeight: 100,
      fontSize: "2rem",
      color: "white",
    },
    datelineLabel: {
      fontFamily: "Grenze",
      fontWeight: 100,
      lineHeight: 1.1,
      fontSize: "1.9rem",
      color: "white",
    },
    movieDescription: {
      fontFamily: "Open Sans",
      fontSize: "1rem",
      color: "white",
    },
    sidebarNumber: {
      fontFamily: "Grenze",
      fontWeight: 200,
      fontSize: "1.65rem",
    },
    sidebarLabel: {
      fontFamily: "Grenze",
      fontWeight: 200,
      fontSize: "0.9rem",
      lineHeight: "0.9",
    },
    languageSelector: {
      fontFamily: "Open Sans",
      fontSize: "1rem",
      fontWeight: 400,
    },
    mobSlideTitle: {
      fontSize: "2.25rem",
      fontFamily: "Grenze",
      fontWeight: 200,
      background: "#000",
      display: "inline-block",
    },
    mobGrenze: {
      fontFamily: "Grenze",
      fontWeight: 200,
    },
    mobSans: {
      fontFamily: "Open Sans",
    },
    mobAbril: {
      fontFamily: "Abril Fatface, Prata",
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    mobRedHat: {
      fontFamily: "Red Hat Display, Open Sans",
      fontSize: "0.875rem",
    },
    mobWhiteBg: {
      fontFamily: "Open Sans",
      fontSize: "0.875rem",
      color: "#000000",
      background: "#fff",
      padding: "5px 2px",
    },
    selectCover: {
      color: "#fff",
      fontFamily: "Open Sans",
      fontSize: "1.5rem",
      lineHeight: "2rem",
      fontWeight: 600,
    },
  },
}
